import React from "react";
import { GroupProps } from "./GroupProps";
import FilterGroup from "./FilterGroup";

const OutletConditionFilter = ({
  groups,
  toggleCollapsed,
  groupsWithMultipleSelections,
  prefetch,
}: GroupProps) => (
  <>
    {groups.map((group) => (
      <FilterGroup
        {...{
          filterText: "condition",
          group,
          toggleCollapsed,
          groupsWithMultipleSelections,
          prefetch,
        }}
        data-testid="OutletConditionFilter"
        key={`conditionFilter-${group.groupNameEncoded}`}
      />
    ))}
  </>
);

export default OutletConditionFilter;
